import React from 'react';

// Chakra imports
import {
   Flex,
   Image,
   Skeleton,
} from '@chakra-ui/react';

import { HSeparator } from 'components/separator/Separator';
import Logo from '../../../assets/img/zeronine.png';

export function SidebarBrand() {
   const [isImageLoaded, setIsImageLoaded] = React.useState(false);
   const [imageError, setImageError] = React.useState(false);

   const handleImageLoad = () => {
      setIsImageLoaded(true);
   };

   const handleImageError = () => {
      setImageError(true);
      setIsImageLoaded(true); // Stop showing skeleton on error
   };

   return (
      <>
         <Flex align="center" direction="column">
            {/* <Zeronine h='26px' w='175px' my='32px' /> */}
            {/* <Icon as={ZeroNineLogo} h='150px' w='200px'  my='-10px' /> */}

            {/* Logo with Skeleton Loader */}
            <Flex position="relative" align="center" justify="center" mb={2}>
               {/* Skeleton shown while image is loading */}
               {!isImageLoaded && (
                  <Skeleton
                     width="200px"
                     height="50px"
                     borderRadius="lg"
                     startColor="gray.200"
                     endColor="gray.300"
                     speed={1}
                  />
               )}

               {/* Logo Image */}
               <Image
                  src={Logo}
                  alt="Zeronine Logo"
                  position={isImageLoaded ? 'static' : 'absolute'}
                  opacity={isImageLoaded ? 1 : 0}
                  transition="opacity 0.3s ease-in-out"
                  onLoad={handleImageLoad}
                  onError={handleImageError}
                  objectFit="contain"
               />

               {/* Fallback if image fails to load */}
               {imageError && (
                  <Flex
                     width="150px"
                     height="80px"
                     align="center"
                     justify="center"
                     bg="gray.100"
                     borderRadius="lg"
                     border="1px dashed"
                     borderColor="gray.300">
                     <span style={{ color: 'gray.500', fontSize: '14px', fontWeight: 'bold' }}>ZERONINE</span>
                  </Flex>
               )}
            </Flex>

            {/* <HorizonLogo h='26px' w='175px' my='32px' color={logoColor} /> */}
            {/* <HSeparator mb="20px" /> */}
         </Flex>
      </>
   );
}

export default SidebarBrand;
